module.exports = "/wp-content/themes/conversion/public/dist//svgs/gain-conversion-white.svg";